module.exports = __webpack_public_path__ + "static/media/soumit.771f338c.JPG";